import NavConfig from './NavConfig';
import { SiteHelper } from '../../common/utils/SiteHelper';
import { MeetingHelper } from '../../common/utils/MeetingHelper';
import { logoutUser } from '../Login/logout';

const NavInit = (header) => {

    //Read nav config
    const navConfig = new NavConfig(header);
    const isLoggedIn = window.hubCookie.exists();
    const welcomeText = isLoggedIn ? navConfig.getLoggedinMessage() : navConfig.getAnonymousMessage();

    const setWelcomeText = (welcomeText) => {
        const welcomeElements = Array.prototype.slice.call(header.querySelectorAll('.js-welcome-text'));
        for (let i = 0; i < welcomeElements.length; i++) {
            welcomeElements[i].textContent = welcomeText;
        }
    };

    const removeMemberOnlyItems = () => {
        if (isLoggedIn || SiteHelper.isIntranetSite()) {
            document.body.classList.add('js-logged');
            return;
        }
        const memberOnlyItems = Array.prototype.slice.call(header.querySelectorAll('.js-member-only'));
        for (let i = 0; i < memberOnlyItems.length; i++) {
            memberOnlyItems[i].parentNode.removeChild(memberOnlyItems[i]);
        }
    };

    const removeLogout = () => {
        const logoutElement = header.querySelector('.js-user-logout');
        if (logoutElement) {
            logoutElement.parentNode.removeChild(logoutElement);
        }
    };

    const handleLogoutLinks = () => {
        const needsLogout = isLoggedIn && navConfig.getShowLogout();
        if (needsLogout) {
            //add logout link handler
            //const logoutLink = header.querySelector('.js-logout-link');
            const logoutLinkdesk = document.getElementsByClassName("js-logout-link")[0]
            logoutLinkdesk.addEventListener('click', (e) => {                
                e.preventDefault();
                logoutUser();
            });
			
			const logoutLinkmob = document.getElementsByClassName("js-logout-link")[1]
            logoutLinkmob.addEventListener('click', (e) => {                
                e.preventDefault();
                logoutUser();
            });

            return;
        }
        removeLogout();
      document.body.classList.remove('js-logged');
    };

    const handlLoginLinks = () => {
        if (!isLoggedIn) {
            document.body.classList.remove('js-logged');
            return;
        }

        const loginLinks = Array.prototype.slice.call(header.querySelectorAll('.js-login-link'));
        for (let i = 0; i < loginLinks.length; i++) {
            loginLinks[i].setAttribute('href', '#');
        }

    };

    const displayName = () => {
        if (!navConfig.getShowName()) {
            return;
        }
        const nameElement = header.querySelector('.js-user-name');
        const name = window.hubCookie.getFirstName();
        if (nameElement && name) {
            nameElement.textContent = `${name}!`;
        }
    };

    const setHeaderLogoLink = () => {
        const link = isLoggedIn ? window.hubConfig.defaultMemberUrl : window.hubConfig.defaultUrl;
        const logoLink = header.querySelector('.js-logo-link');
        if(logoLink){
        logoLink.setAttribute('href', link);
    }
    };

    const handleVirtualMeetingLink = () => {
        const links = Array.prototype.slice.call(header.querySelectorAll('.js-virtual-meeting-link'));
        if (!(links && links.length)) {
            return;
        }

        //try to identify the browser. If it's safari, the virtual meeting link should go to mediasite
        const isSafari = SiteHelper.isSafariUser();

  

        for (let i = 0; i < links.length; i++) {
            const link = links[i];
            if (isSafari) {
                //add a querystring param to the URL so that mediasite can render the fullsite experience
                const targetLinkAttr = 'data-target-link';
                const targetLinkAttrid = link.dataset.linkIdClass
                const url = MeetingHelper.getLink(targetLinkAttrid);
                link.setAttribute(targetLinkAttr, url);
            
                link.setAttribute('target', '_blank');
                link.setAttribute('rel', 'nofollow');
            } else {
                link.classList.remove('js-secure-linkout');
            }
        }



       
    };

    removeMemberOnlyItems();
    setWelcomeText(welcomeText);
    displayName();
    handleLogoutLinks();
    handlLoginLinks();
    setHeaderLogoLink();
    handleVirtualMeetingLink();
}

export { NavInit };


// WEBPACK FOOTER //
// ./src/nams2020/webparts/Header/NavInit.js